import { type TableDataCellProps, type TableHeadCellProps, Text } from "@mdotm/shadcn/legacy/components";
import { overrideClassName, renderNodeOrFn } from "@mdotm/shadcn/legacy/react-extensions";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";
import type { CSSProperties } from "react";

export function TinyTableHeadCell<K extends string = string>(props: TableHeadCellProps<K>): React.JSX.Element {
	const renderedChildren = renderNodeOrFn(props.children);
	return (
		<div
			style={{ ...props.style, minHeight: 31 }}
			className={overrideClassName(
				{
					"flex items-center": true,
					"justify-start": !props.align || props.align === "start",
					"justify-center": props.align === "middle",
					"justify-end": props.align === "end",
				},
				props.className,
			)}
		>
			<Text
				color={themeCSSVars.palette_N500}
				type="Body/S/BOLD-UPPERCASE"
				style={{ fontSize: tinyTableHeadCellFontSize }}
				className={{
					"line-clamp-2": true,
					"text-left": !props.align || props.align === "start",
					"text-right": props.align === "end",
					"text-center": props.align === "middle",
				}}
				title={typeof renderedChildren === "string" ? renderedChildren : undefined}
			>
				{renderedChildren}
			</Text>
		</div>
	);
}

export const tinyTableDataCellFontSize = 10;
export const tinyTableHeadCellFontSize = 7.71;

export function TinyTableDataCell(
	props: TableDataCellProps & { fontSize?: CSSProperties["fontSize"]; lineClamp?: number },
): React.JSX.Element {
	const renderedChildren = renderNodeOrFn(props.children);
	return (
		<div
			style={{ ...props.style, minHeight: 31 }}
			className={overrideClassName(
				{
					"flex items-center": true,
					"justify-start": !props.align || props.align === "start",
					"justify-center": props.align === "middle",
					"justify-end": props.align === "end",
				},
				props.className,
			)}
		>
			<Text
				type="Body/S/Book"
				style={{
					fontSize: props.fontSize ?? tinyTableDataCellFontSize,
					overflow: "hidden",
					display: "-webkit-box",
					WebkitBoxOrient: "vertical",
					WebkitLineClamp: props.lineClamp ?? 2,
				}}
				className={{
					"text-left": !props.align || props.align === "start",
					"text-right": props.align === "end",
					"text-center": props.align === "middle",
				}}
				title={typeof renderedChildren === "string" ? renderedChildren : undefined}
			>
				{renderedChildren}
			</Text>
		</div>
	);
}
